import Message from 'formvalidation/plugins/Message';
import Trigger from 'formvalidation/plugins/Trigger';
import SubmitButton from 'formvalidation/plugins/SubmitButton';
import ValidationUtils from '../../utils/validation';
import { PASSWORD_REGEX } from '../../utils/form-validation';

const passwordValidationRules = (editPasswordForm) => ({
	fields: {
		currentPassword: {
			validators: {
				notEmpty: {
					message: 'Please enter your current password'
				}
			}
		},
		newPassword: {
			validators: {
				notEmpty: {
					message: 'Please enter a new password'
				},
				regexp: {
					regexp: PASSWORD_REGEX,
					message: 'Please enter 8–25 characters with at least one upper case, one lower case, one number and one special character (!@#$%^&*()_+-=)'
				},
			}
		},
		repeatPassword: {
			validators: {
				identical: {
					compare: () => editPasswordForm.querySelector('[name="newPassword"]').value,
					message: 'Please enter the same password twice'
				},
			}
		}
	},
	plugins: {
		trigger: new Trigger(),
		submitButton: new SubmitButton(),
		message: new Message({
			clazz: 'lta-text-input__label-instruction',
			container: function(field, element) {
				const fieldType = element.getAttribute('type');
				const inputWrapper = element.closest(ValidationUtils.getFieldWrapper(fieldType));
				return inputWrapper.querySelector('.lta-text-input--error');
			}
		}),
	}
})

export default passwordValidationRules;
